import { VNode } from 'vue';

import DesignComponent from './designComponent';

export default new DesignComponent({
  info: {
    title: 'Image',
    img: new URL('../../../assets/img/icons/image.svg', import.meta.url).href
  },
  structure: {
    tag: 'ion-img',
    data: {
      props: {
        designId: 'image',
        configurable: 'Image'
      },
      attrs: {
        src: '/img/brand/cmlogo.png',
        draggable: true
      },
      style: {
        margin: '0 auto',
        width: '100%',
        height: '250px',
        padding: '1em',
        background: 'rgb(255,255,255)'
      },
      class: []
    }
  },
  settings: [
    {
      label: 'Source Url',
      inputType: 'text',
      get: (vnode: VNode) => vnode.data.attrs.src,
      set: (vnode: VNode, value) => (vnode.data.attrs.src = value)
    },
    {
      label: 'Width',
      inputType: 'text',
      get: (vnode) => vnode.data.style.width.replace('px', ''),
      set: (vnode, value) => (vnode.data.style.width = value + 'px')
    },
    {
      label: 'Height',
      inputType: 'text',
      get: (vnode) => vnode.data.style.height.replace('px', ''),
      set: (vnode, value) => (vnode.data.style.height = value + 'px')
    }
  ]
});
